import { useEffect, useState } from "react";
import axios from "axios";

let cache;
let pending;

function useConfig() {
  const [data, setData] = useState(cache || null);
  useEffect(() => {
    if (cache) return;
    pending =
      pending ||
      axios
        .get(`${process.env.REACT_APP_BACKEND_URL}/api/public/insights`)
        .then((r) => {
          cache = r.data;
          return cache;
        })
        .catch(() => ({}));
    pending.then((d) => setData(d));
  }, []);
  return data;
}

export function useInsights() {
  const d = useConfig();
  return d ? d.insights || {} : null;
}

export function useQuestions() {
  const d = useConfig();
  return d ? { questions: d.questions || [], descriptions: d.topic_descriptions || {} } : null;
}

export const clearInsightsCache = () => {
  cache = undefined;
  pending = undefined;
};
